import {DataTableColumn} from "../../../DataTable/DataTable"
import {TtaMappedPairEntity} from "@ots-frontend/ots-data";
import type {ReactNode} from "react";
import {Group, Text} from "@mantine/core";
import {IconCircleXFilled} from "@tabler/icons-react";

export type CompareColumn = Omit<DataTableColumn<TtaMappedPairEntity>, 'customCellAttributes' | 'render' | 'noWrap' | 'ellipsis'> & {
  isEqual: (record: TtaMappedPairEntity) => boolean,
  render: (record: TtaMappedPairEntity, index: number) => ReactNode
}

export const getCompareColumn = (props: CompareColumn): DataTableColumn<TtaMappedPairEntity> => {
  const {isEqual, render, ...rest} = props

  return {
    ...rest,
    customCellAttributes: (record) => {
      const attrs: Record<string, unknown> = {}

      if (!record.dbTta) {
        attrs["bg"] = "gray.3"
      }

      return attrs
    },
    render: (record, index) => {
      return (
        <Group spacing="xs">
          {!isEqual(record) &&
            <Text c="red">
              <IconCircleXFilled size={14}/>
            </Text>
          }
          {render(record, index)}
        </Group>
      )
    }
  }
}
